// src/services/api.ts
import API_BASE_URL from '../utils/apiBase';

interface PdfProduct {
  id: number;
  title: string;
  description: string;
  price: number;
  category?: string;
  file_name: string;
  file_url: string;
  file_size?: number;
  created_at: string;
  updated_at?: string;
}

class PublicApiService {
  async getPdfs(category?: string): Promise<PdfProduct[]> {
    let url = `${API_BASE_URL}/pdfs`;
    if (category && category !== 'all') {
      url += `?category=${encodeURIComponent(category)}`;
    }

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error('Failed to fetch PDFs');
    }

    return response.json();
  }

  async getPdf(id: number): Promise<PdfProduct> {
    const response = await fetch(`${API_BASE_URL}/pdfs/${id}`);

    if (!response.ok) {
      throw new Error('Failed to fetch PDF');
    }

    return response.json();
  }

  async getCategories(): Promise<string[]> {
    const response = await fetch(`${API_BASE_URL}/pdfs/categories/list`);

    if (!response.ok) {
      throw new Error('Failed to fetch categories');
    }

    return response.json();
  }
}

export const publicApi = new PublicApiService();
export type { PdfProduct };
